import React, { ChangeEvent } from "react";
import { Stack, RadioGroup, Radio } from "@origin-digital/ods-core";
import { Field, FieldProps } from "formik";
import { HandoverTypeEnum } from "../../types";
import { handoverTypeToMsg } from "../helper";
import { CTReadOnlyHeader } from "../CTReadOnlyHeader";
import FormFieldLayout from "../../FormComponents/FormFieldLayout";
import { useCloseTransferFormProps } from "./useCloseTransferFormProps";

export const CloseTransferFormAutomatedHeaderSection: React.FC = () => {
  const {
    formBehavior: { isElectricityReadOnly, isGasReadOnly },
    formikContext: { values, setFieldValue },
  } = useCloseTransferFormProps();

  const { closeTransfer } = values;
  const isHeaderReadOnly = isElectricityReadOnly || isGasReadOnly;

  if (isHeaderReadOnly) {
    return (
      <CTReadOnlyHeader
        handoverType={closeTransfer.handoverType}
        attachment={closeTransfer.fileMeta}
      />
    );
  }
  const handleCloseToggle = (event: ChangeEvent<HTMLInputElement>) => {
    if (
      event.target.checked &&
      values.closeTransfer.accountHolder !== undefined
    ) {
      setFieldValue("closeTransfer.accountHolder", undefined);
    }
  };

  return (
    <Stack>
      <FormFieldLayout>
        <Field name="closeTransfer.handoverType">
          {({ field }: FieldProps) => (
            <RadioGroup
              {...field}
              id="close-transfer-handover"
              name="closeTransfer.handoverType"
              label="Would you like to transfer or close the accounts?"
            >
              <Radio
                id="transfer"
                label={handoverTypeToMsg[HandoverTypeEnum.CLOSE_AND_TRANSFER]}
                value={HandoverTypeEnum.CLOSE_AND_TRANSFER}
                helperText="We will close your account and you can provide us with the customer’s details so we can contact them to ask them to set up an account with us."
              />
              <Radio
                id="close"
                label={handoverTypeToMsg[HandoverTypeEnum.CLOSE]}
                value={HandoverTypeEnum.CLOSE}
                helperText="Close the account and de-energise the site."
                onChange={(e) => {
                  handleCloseToggle(e);
                }}
              />
            </RadioGroup>
          )}
        </Field>
      </FormFieldLayout>
    </Stack>
  );
};
